import type { AuthenticatedUser } from "@climatepartner/app-shell/auth";

/** `userList` is a comma-separated list of ClimatePartner mailbox names, matched case-insensitively. */
export const createExcludeUser = (userList: string): ((user: AuthenticatedUser) => boolean) => {
  const names = userList.split(",").filter(Boolean);
  if (names.length === 0) {
    return () => false;
  }

  const namePattern = new RegExp(names.join("|"), "i");
  return (user) => {
    const [mailbox, domain] = user.email?.split("@") ?? ["", ""];
    return namePattern.test(mailbox) && domain === "climatepartner.com";
  };
};

export const excludeUser = createExcludeUser(import.meta.env.VITE_USERS_TO_EXCLUDE_FOR_DATADOG ?? "");
